// AlumniData.js

export const PHD_STUDENTS = [
  {
    name: "Ahmed Omara",
    text: "University of Ottawa, Ph.D. in Electrical and Computer Engineering awarded in October 2024.",
    position: "Machine Learning Engineer in Department of National Defense",
  },
  {
    name: "Bin Xiao",
    text: "University of Ottawa, Ph.D. in Computer Science awarded in September 2024.",
    position: "Postdoctoral researcher at University Health Network (UHN)",
  },
  {
    name: "Zhiyan Chen",
    text: "University of Ottawa, Ph.D. in Electrical and Computer Engineering awarded in June 2023.",
    position: "Fortinet; machine learning security engineer",
  },
  {
    name: "Liu Jinxin",
    text: "University of Ottawa, Ph.D. in Electrical and Computer Engineering awarded in June 2023.",
    position: "Huawei",
  },
  {
    name: "Andressa Vergütz",
    text: "University of Ottawa, Ph.D. in Computer Science awarded in June 2022.",
    position: "Haijunka 360 co-founder",
  },
  {
    name: "Safa Otoom",
    text: "University of Ottawa, Ph.D. in Electrical and Computer Engineering awarded in June 2019.",
    position: "Assistant Professor, Zayed University-Abu Dhabi",
  },
  {
    name: "Maryam Pouryazdanpanah",
    text: "Clarkson University, Ph.D in ECE awarded in August 2018.",
    position: "IoT-Data Scientist, Watts Water Technologies (Boston, MA)",
  },
  {
    name: "Fazel Anjomshoa",
    text: "Clarkson University, Ph.D in ECE awarded in May 2018",
    position: "Data Scientist at Roku Inc., (Boston ,MA)",
  },
  {
    name: "Claudio Fiandrino",
    text: "University of Luxembourg (visiting phd student), PhD in Computer Science awarded in November 2017",
    position: "Postdoctoral researcher, Imdea Networks (Madrid, Spain)",
  },
  {
    name: "Riccardo Venanzi",
    text: "(Visiting PhD student from University of Ferrara, Italy)",
    position: "Ph.D candidate in Computer Science, University of Ferrara, Italy",
  },
  {
    name: "Dimitri Belli",
    text: ", (Visiting PhD student from University of Pisa, Italy)",
    position: "Ph.D candidate in Computer Science, University of Pisa, Italy",
  },
];

export const MASTERS_STUDENTS = [
  {
    name: "Mahsa Paknejad",
    text: "University of Ottawa, Master in Electrical and Computer Engineering awarded in 2025.",
    position: "Machine Learning Specialist, Qoherent Inc.",
  },
  {
    name: "Lansu Dai",
    text: "University of Ottawa, Master in Computer Science awarded in 2025.",
    position: "Ph.D student, University of Ottawa",
  },
  {
    name: "Xuli Cai",
    text: "University of Ottawa, Master in Computer Science awarded in 2025.",
    position: "Ph.D student, University of Ottawa",
  },
  {
    name: "Mohammed Sufiyan Ali Banaganapalle",
    text: "University of Ottawa, Master in Elec. and Comp. Eng in 2025.",
    position: "ROS Engineer in Aurrigo",
  },
  {
    name: "Claire Zhang",
    text: "University of Ottawa, Master in System Science awarded in 2024.",
    position: "Research Trainee, European Space Agency",
  },
  {
    name: "Murat Arda Onsu",
    text: "University of Ottawa, Master in Computer Science awarded in 2023.",
    position: "Ph.D student, University of Ottawa",
  },
  {
    name: "Mohsen Shahbazi",
    text: "University of Ottawa, Master in Electrical and Computer Engineering awarded in 2023.",
    position: "Cisco",
  },
  {
    name: "Nahid Parvaresh",
    text: "University of Ottawa, Master in Computer Science awarded in 2023",
    position: "Senior AI Risk Consultant, EY",
  },
  {
    name: "Yu Shen",
    text: "University of Ottawa, Master in Electrical and Computer Engineering awarded in 2022.",
    position: "Nokia",
  },
  {
    name: "Johan Fernandes",
    text: "University of Ottawa, Master in Computer Science awarded in 2022.",
    position: "Statistics Canada",
  },
  {
    name: "Yakup Akkaya",
    text: "University of Ottawa, Master in Electrical and Computer Engineering awarded in 2022.",
    position: "J.D. Power",
  },
  {
    name: "Cem Mumtaz Eris",
    text: "Master in Computer Science awarded in 2022.",
    position: "Entrapeer",
  },
  {
    name: "Sedevizo Kielienyu",
    text: "Master of Computer Science, uOttawa, August 2020",
    position: "Data Scientist, Coastal Resource Mapping (CRM), Vancouver, BC",
  },
  {
    name: "Ji Chu Jiang",
    text: "Master of Applied Science, Electrical and Computer Engineering, uOttawa, December 2020",
    position: "Software Engineer at Lytica Inc., Ottawa, ON",
  },
  {
    name: "Kyle Quintal",
    text: "Master of Computer Science, University of Ottawa, August 2020",
    position: "Data Scientist, AedoAI (Calgary, AB)",
  },
  {
    name: "Yueqian Zhang",
    text: "Master of Computer Science, University of Ottawa, Dec 2019",
    position: "Recent graduate",
  },
  {
    name: "Ahmed Omara",
    text: "Master of Applied Science in Electrical and Computer Engineering, University of Ottawa, Dec 2019",
    position: "Ph.D student, University of Ottawa",
  },
  {
    name: "Ertugrul Kara",
    text: "Master of Computer Science, University of Ottawa, July 2019",
    position: "Software Engineer, Amazon (Vancouver, BC)",
  },
  {
    name: "Venkat Surya Dasari",
    text: "Master of Applied Science in Electrical and Computer Engineering, University of Ottawa, July 2019",
    position: "Researcher",
  },
  {
    name: "Ankkita Sood",
    text: "Master of Computer Science, University of Ottawa, June 2019",
    position: "Data analyst, Kinaxis (Ottawa, ON)",
  },
  {
    name: "Cem Kaptan",
    text: "Master of Computer Science, University of Ottawa, August 2018",
    position: "Software Developer, Wirkn (Montréal, QC) (also continuing Ph.D at NEXTCON",
  },
  {
    name: "Zachary I. Rauen",
    text: "M.Sc in Electrical Engineering, Clarkson University, May 2018",
    position: "Firmware/Security Team member, IBM (Schenectady, NY)",
  },
  {
    name: "Wendong Yuan",
    text: "Master of Computer Science, University of Ottawa, June 2018",
    position: "oftware Engineer at Fortinet Inc. (Ottawa, ON)",
  },
  {
    name: "George Patrick Xavier",
    text: "Master of Computer Science, University of Ottawa, June 2018",
    position: "Digital Integration Solutions Developer at Deloitte Canada (Montréal, QC)",
  },
  {
    name: "Damanpreet Singh",
    text: "Master of Computer Science, University of Ottawa, June 2018",
    position: "Current Position and Affiliation: Software Development Engineer, IBM (Ottawa, ON)",
  },
];

export const POSTDOC_AND_ASSOC = [
  { name: "Dr. Murat Simsek", year: "2025", position: "Assistant Professor, SUNY- Canton |" },
  { name: "Dr. Michel Kulhandjian", year: "2025", position: "Senior Research Scientist in Rice University |" },
  {
    name: "Dr. Aynur Zhumadillayeva",
    year: "2024",
    position: "Associate PRofessor at L.N Gumilov Eurasian NAtional University |",
  },
  { name: "Othmane Friha", year: "2024", position: "Assistant Professor at University of Algiers |" },
  {
    name: "Omer Melih Gül",
    year: "2023",
    position: "Associate Professor in the Informatics Institute at Istanbul Technical University (ITU) |",
  },
  { name: "Tuerxun Wali", year: "2022", position: "Gnowi |" },
];

export const NON_RESEARCH_HQP = [{ name: "Ade Ogunlami", year: "2024" }];

export const UNDERGRADS = [
  {
    name: "Oliver Benning",
    text: "(University of Ottawa, Computer Science Honours Project), June 2020",
    position: "Master of Computer Science student, University of Ottawa, ON",
  },
  {
    name: "Xuankai Chen",
    text: "(University of Ottawa, Computer Science Honors Project, January 2020, 2nd Winner of Cognos Prize, Fall 2019)",
    position: "Software Engineer, Capital One, Toronto, ON",
  },
  {
    name: "Mark Traquair",
    text: "(University of Ottawa, Computer Science Honors Project, June 2019, Winner of Cognos Prize winter 2019)",
    position: "Machine Learning Developer, Summatti, Waterloo, ON",
    link: {
      href: "https://www.linkedin.com/posts/bkantarci_nextconlab-congratulations-research-activity-6537056234145660928-pwCj/",
      label: "Winner of Cognos Prize winter 2019",
    },
  },
  {
    name: "Asish Khiani",
    text: "(University of Ottawa, Computer Science Honors Project, June 2019)",
    position: "Associate Software Engineer, Capital One, Toronto, ON",
  },
  { name: "Alek Hadzidedic", text: "(University of Ottawa, Computer Science Honors Project, June 2019)", position: "-" },
  { name: "Nicholas Jordan", text: "(University of Ottawa, Computer Science Honors Project, Dec. 2018)", position: "Data Forensic Analyst" },
  { name: "Nikita Pekin", text: "(University of Ottawa, Computer Science Honors Project, Dec. 2018)", position: "Kandy Software Designer, Ribbon Communications" },
  {
    name: "Irem Ural",
    text: "(Visiting student from Bilkent University- Department of Computer Engineering in Summer 2018)",
    position: "4-th year student in Computer Engineering major at Bilkent University, Turkey",
  },
  {
    name: "Kyle Quintal",
    text: "(University of Ottawa, Capstone project in Software Engineering, May 2018)",
    position: "Master of Computer Science student, University of Ottawa (continuing Master at NEXTCON)",
  },
  {
    name: "Philip A. K. Lorimer",
    text: "(University of Ottawa, Capstone project in Software Engineering, May 2018)",
    position: "Software Engineer, Communication Security Establishment Canada",
  },
  { name: "Alan Ross-Ross", text: "(University of Ottawa, Capstone project in Software Engineering, May 2018)", position: "Software Engineer at Ribbon Communications, Ottawa, ON" },
  { name: "Shawn Lamothe", text: "(University of Ottawa, Capstone project in Software Engineering, May 2018)", position: "Software Engineer, Electronic Arts-EA, (Vancouver, BC)" },
  { name: "Zachary Paquette", text: "(University of Ottawa, Capstone project in Software Engineering, May 2018)", position: "-" },
  { name: "Jing Yi Dai", text: "(University of Ottawa, Capstone project in Software Engineering, May 2018)", position: "-" },
  { name: "Michael Abourahal", text: "(University of Ottawa, Computer Science Honors Project, May 2018)", position: "4-th year student at University of Ottawa" },
  { name: "Samer Akiki", text: "(Clarkson-ECE Honors Student. Graduated in May 2017)", position: "Product Engineer at Globalfoundaries, San Diego, CA" },
  {
    name: "Alexander Cartier",
    text: "(Clarkson-CompE undergraduate, Graduated in May 2016. Directed Study in Spring 2015, on Scalable Platforms for Internet of Things)",
    position: "-",
  },
  {
    name: "Connor D. Pearsall",
    text: "(Clarkson-SoftE graduate, Cloud Systems and Networks in Spring 2015, co-author of a paper on Cloud and Smart cities)",
    position: "Collaborator",
  },
  {
    name: "David Lee",
    text: "(Clarkson-CompE undergraduate, Graduated in 2016. Directed Study in Spring 2015, on Scalable Platforms for Internet of Things)",
    position: "Product Engineer at Globalfoundaries, San Diego, CA",
  },
  {
    name: "Kevin Carr",
    text: "(Clarkson-SoftE graduate, Cloud Systems and Networks in Spring 2015, co-author of a paper on Cloud and Smart cities)",
    position: "Collaborator",
  },
  {
    name: "P. M. Glasser",
    text: "(Clarkson-EE MSc graduate, Cloud Systems and Networks in Spring 2015 co-author of a paper on mobile social networks in IEEE GLOBECOM 2015)",
    position: "Collaborator",
  },
];